module.exports = __webpack_public_path__ + "0d1afa937de7a064f086502822572ca0.pdf";